export default "__VITE_ASSET__DsEJW4O2__"